export const getDisplayUsername = (username?: string) => {
  return username ? (username.startsWith('@') ? username : `@${username}`) : ''
}
